"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardChart = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const react_1 = __importStar(require("react"));
const victory_1 = require("victory");
const ChartStyles_1 = require("./ChartStyles");
function StandardChart(props) {
    const { ySuffix, xLabels, onClickDatum, domain, onMouseEnterDatum, onMouseLeaveDatum, onClickTick, onMouseEnterTick, onMouseLeaveTick, padding = 5, width = 400, height = 150, fontSize, children, svgComponents, tickFormat, } = props;
    let calcFontSize = Math.max(Math.min(fontSize ? fontSize : Math.ceil(height / 18), 20), 14);
    const xLabelHeight = calcFontSize * 2 + 2;
    const yLabelWidth = 28;
    const dataEvents = (0, react_1.useMemo)(() => onClickDatum || onMouseEnterDatum || onMouseLeaveDatum
        ? [
            {
                childName: 'all',
                target: 'data',
                eventHandlers: {
                    onClick: onClickDatum || doNothing_1.default,
                    onMouseEnter: onMouseEnterDatum || doNothing_1.default,
                    onMouseLeave: onMouseLeaveDatum || doNothing_1.default,
                },
            },
        ]
        : undefined, [onClickDatum, onMouseEnterDatum, onMouseLeaveDatum]);
    const axisEvents = (0, react_1.useMemo)(() => onClickTick || onMouseEnterTick || onMouseLeaveTick
        ? [
            {
                target: 'tickLabels',
                eventHandlers: {
                    onClick: onClickTick || doNothing_1.default,
                    onMouseEnter: onMouseEnterTick || doNothing_1.default,
                    onMouseLeave: onMouseLeaveTick || doNothing_1.default,
                },
            },
        ]
        : undefined, [onClickTick, onMouseEnterTick, onMouseLeaveTick]);
    const axisStyle = (0, react_1.useMemo)(() => !xLabels
        ? {
            axis: { stroke: 'transparent' },
            ticks: { stroke: 'transparent' },
            tickLabels: { fill: 'transparent' },
        }
        : !xLabels.length
            ? {
                axis: ChartStyles_1.ChartStyles.axis,
                ticks: { stroke: 'transparent' },
                tickLabels: { fill: 'transparent' },
            }
            : {
                axis: ChartStyles_1.ChartStyles.axis,
                ticks: ChartStyles_1.ChartStyles.ticks,
                tickLabels: Object.assign(Object.assign({}, (axisEvents
                    ? ChartStyles_1.ChartStyles.tickLabelsClickable
                    : ChartStyles_1.ChartStyles.tickLabels)), { fontSize: calcFontSize }),
            }, [axisEvents, calcFontSize, xLabels]);
    const yTickFormat = (0, react_1.useMemo)(() => v => v + (ySuffix || ''), [ySuffix]);
    const domainPadding = (0, react_1.useMemo)(() => {
        return !xLabels ? { x: 0, y: 0 } : { x: xLabelHeight, y: 0 };
    }, [xLabels, xLabelHeight]);
    const viewBox = !!(xLabels === null || xLabels === void 0 ? void 0 : xLabels.length)
        ? `-${yLabelWidth},-${xLabelHeight},${width + yLabelWidth * 2},${height + xLabelHeight * 2}`
        : `0,0,${width},${height}`;
    const chartHeight = Math.max(0, height);
    return (0, react_1.useMemo)(() => {
        if (!width || !height)
            return null;
        return (react_1.default.createElement("svg", { width: width, height: height, viewBox: viewBox },
            svgComponents,
            react_1.default.createElement(victory_1.VictoryChart, { width: width, height: chartHeight, padding: padding, domain: domain, domainPadding: domainPadding, standalone: false, events: dataEvents },
                react_1.default.createElement(victory_1.VictoryAxis, { style: axisStyle, events: axisEvents, tickValues: xLabels, tickFormat: tickFormat }),
                react_1.default.createElement(victory_1.VictoryAxis, { dependentAxis: true, style: axisStyle, tickFormat: yTickFormat }),
                children)));
    }, [
        width,
        height,
        viewBox,
        svgComponents,
        chartHeight,
        padding,
        domain,
        domainPadding,
        dataEvents,
        axisStyle,
        axisEvents,
        xLabels,
        tickFormat,
        yTickFormat,
        children,
    ]);
}
exports.StandardChart = StandardChart;
exports.default = StandardChart;
